import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import mutationDocument from "./changeCartCurrencyForSavedShoppingCartsMutation.graphql";
import type { CartExtension, Mutations, MutationsChangeCartCurrencyForSavedCartsArgs } from "@/core/api/graphql/types";

export async function changeCartCurrencyForSavedShoppingCarts(
  cartId: string,
  newCurrencyCode: string,
  cartName?: string,
  oldCurrencyCode?: string,
): Promise<CartExtension> {
  const { storeId, userId, currencyCode, cultureName } = globals;

  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "changeCartCurrencyForSavedCarts">>,
    MutationsChangeCartCurrencyForSavedCartsArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        cartId,
        userId,
        storeId,
        currencyCode: oldCurrencyCode ?? currencyCode,
        cultureName,
        newCurrencyCode,
        cartName,
      },
    },
  });

  return data!.changeCartCurrencyForSavedCarts as CartExtension;
}
